function ShieldIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.9999 22.76C10.9099 22.76 9.8299 22.44 8.9799 21.81L4.6799 18.6C3.5399 17.75 2.6499 15.97 2.6499 14.56V7.12C2.6499 5.58 3.7799 3.94 5.2299 3.4L10.2199 1.53C11.2099 1.16 12.7699 1.16 13.7599 1.53L18.7499 3.4C20.1999 3.94 21.3299 5.58 21.3299 7.12V14.55C21.3299 15.97 20.4399 17.74 19.2999 18.59L14.9999 21.8C14.1699 22.44 13.0899 22.76 11.9999 22.76ZM10.7499 2.94L5.7599 4.81C4.9099 5.13 4.1599 6.21 4.1599 7.13V14.56C4.1599 15.51 4.8299 16.84 5.5799 17.4L9.8799 20.61C11.0299 21.47 12.9699 21.47 14.1299 20.61L18.4299 17.4C19.1899 16.83 19.8499 15.51 19.8499 14.56V7.12C19.8499 6.21 19.0999 5.13 18.2499 4.8L13.2599 2.93C12.5799 2.69 11.4199 2.69 10.7499 2.94Z"
        fill="#292D32"
        className="fill"
      />
      <path
        d="M10.6602 14.23C10.4702 14.23 10.2802 14.16 10.1302 14.01L8.52023 12.4C8.23023 12.11 8.23023 11.63 8.52023 11.34C8.81023 11.05 9.29023 11.05 9.58023 11.34L10.6602 12.42L14.4302 8.65C14.7202 8.36 15.2002 8.36 15.4902 8.65C15.7802 8.94 15.7802 9.42 15.4902 9.71L11.1902 14.01C11.0402 14.16 10.8502 14.23 10.6602 14.23Z"
        fill="#292D32"
        className="fill"
      />
    </svg>
  );
}

export default ShieldIcon;
